/* The checkout's sign-in block (prototype .signin), in the telify layer. */
@layer telify {
  .signin {
    display: grid;
    gap: 18px;
    justify-items: start;
  }

  .lead {
    font-size: 16px;
    line-height: 1.6;
    color: var(--text-secondary);
    max-width: 50ch;
  }

  .btnTg {
    background: var(--accent);
    color: var(--text-on-accent);
    min-width: 300px;
  }

  .btnTg:disabled {
    opacity: 0.6;
    cursor: default;
  }

  .error {
    font-size: 14px;
    color: var(--spots-low-color);
  }

  .welcome {
    width: 100%;
    padding: 12px 16px;
    border-radius: var(--r-ctl);
    background: var(--tint);
    font-size: 15px;
    color: var(--text-primary);
  }

  .noTg {
    width: 100%;
    padding-top: 16px;
    border-top: 1px solid var(--border-subtle);
    font-size: 14px;
    line-height: 1.6;
    color: var(--text-tertiary);
  }

  .noTg b {
    color: var(--text-secondary);
    font-weight: 600;
  }

  .noTg a {
    white-space: nowrap;
    color: var(--text-secondary);
    text-decoration: underline;
    text-underline-offset: 3px;
    text-decoration-color: var(--text-muted);
  }

  /* web-studio-sites D12: on a custom site's narrow page the Telegram button spans the column (bookings.html .btnTg at 860 pixels). */
  @media (max-width: 860px) {
    :global(:root[data-custom-site]) .btnTg {
      min-width: 0;
      width: 100%;
    }
  }
}
